export default "__VITE_ASSET__DuWy0RbB__"